import { type ColumnDefinition } from '@approvalmax/ui/src/components';
import { z } from 'zod';

import { personSchema } from '../../schema';
import { PersonRowControls } from '../PersonRowControls/PersonRowControls';
import { getRoles } from './PersonsTable.helpers';
import { messages } from './PersonsTable.messages';

export const columns: ColumnDefinition<z.infer<typeof personSchema> & { id: string }>[] = [
    {
        id: 'name',
        name: messages.name,
        sortable: false,
    },
    {
        id: 'roles',
        name: messages.role,
        sortable: false,
        width: 100,
        value: (item) => getRoles(item.roles),
    },

    {
        id: 'controls',
        sortable: false,
        width: 24,
        spacing: '8',
        value: (item) => <PersonRowControls {...item} />,
    },
];
